// For more information about this file see https://dove.feathersjs.com/guides/cli/service.shared.html

import type { ClientApplication } from '../../client';
import type { AuthenticationManagementService } from '../../feathers-authentication-management';

export const authManagementPath = 'api/auth-management';

export const authManagementMethods: Array<keyof AuthenticationManagementService> = [
  'verifySignupLong',
  'create',
];

import type { SanitizedUser } from '../../feathers-authentication-management/types';
export type { SanitizedUser };

export const authManagementClient = (client: ClientApplication) => {
  const connection = client.get('connection');

  client.use(authManagementPath, connection.service(authManagementPath), {
    methods: authManagementMethods,
  });
};

// Add this service to the client service type index
declare module '../../client' {
  interface ServiceTypes {
    [authManagementPath]: AuthenticationManagementService;
  }
}
